import { GET_CITIES, GET_CITIES_ERROR, GET_CITIES_SUCCESS  } from '../actions/CitiesActions';

const INITIAL_STATE = {
    cityList: [],
    loading: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {  
        case GET_CITIES:
            return {...state, cityList: action.payload.data || [], loading: true};
        case GET_CITIES_ERROR:
            return {...state, loading: false};
        case GET_CITIES_SUCCESS:
            return {...state, loading: false};
        default:
            return state;
    }
}
